import { Box, Typography } from '@mui/material';

import { FCheckbox } from '../../../base';
import { getThemeColor } from '../../../../utils/common';
import { Themes } from '../../../../constants';
import { BT_SPVSN_ENUM } from './constants';

import type { ITableHeaderConfig } from '../../../../utils/types';
import type { ChangeEvent } from 'react';

interface BtSupervisionTableRowProps {
  value: string;
  headerConfig: Array<ITableHeaderConfig>;
  isEditable: boolean;
  selectedValue: { key: string; value: any };
  onChange: (key: string, value: string) => void;
}

function BtSupervisionTableRow(props: BtSupervisionTableRowProps) {
  const { value, headerConfig, isEditable, selectedValue, onChange } = props;

  const handleFieldUpdate = (field: string, value: string) => {
    if (!field) return;
    onChange(field, value);
  };

  return (
    <Box
      sx={{
        height: 40,
        display: 'flex',
        py: 0.5,
        pl: 3,
        width: 'calc(100% + 4px)',
        marginLeft: '-2px',
        alignItems: 'center',
      }}
    >
      <Box sx={{ flex: 1, flexGrow: 1, textAlign: 'left', fontSize: 16 }}>
        <Typography>{value}</Typography>
      </Box>
      <Box sx={headerConfig[1].sx}>
        <FCheckbox
          data-testid={`${BT_SPVSN_ENUM.NEEDS_IMPROVEMENT}_${selectedValue.key}`}
          sx={{ margin: 0, flexGrow: 1, justifyContent: 'center', pointerEvents: 'none' }}
          iconStyles={{ pointerEvents: 'auto' }}
          disabled={!isEditable}
          checked={BT_SPVSN_ENUM.NEEDS_IMPROVEMENT === selectedValue.value}
          onChange={(_e: ChangeEvent<HTMLInputElement>) => {
            handleFieldUpdate(selectedValue.key, BT_SPVSN_ENUM.NEEDS_IMPROVEMENT);
          }}
        />
      </Box>
      <Box
        sx={{
          height: '100%',
          borderLeft: `1px solid ${getThemeColor(Themes.Primary).primary}`,
          borderRadius: '2px',
          marginLeft: '-2px',
        }}
      ></Box>

      <Box sx={headerConfig[2].sx}>
        <FCheckbox
          data-testid={`${BT_SPVSN_ENUM.MEETS_EXPECTATIONS}_${selectedValue.key}`}
          sx={{ margin: 0, flexGrow: 1, justifyContent: 'center', pointerEvents: 'none' }}
          iconStyles={{ pointerEvents: 'auto' }}
          disabled={!isEditable}
          checked={BT_SPVSN_ENUM.MEETS_EXPECTATIONS === selectedValue.value}
          onChange={(_e: ChangeEvent<HTMLInputElement>) => {
            handleFieldUpdate(selectedValue.key, BT_SPVSN_ENUM.MEETS_EXPECTATIONS);
          }}
        />
      </Box>
      <Box
        sx={{
          height: '100%',
          borderLeft: `1px solid ${getThemeColor(Themes.Primary).primary}`,
          borderRadius: '2px',
          marginLeft: '-2px',
        }}
      ></Box>

      <Box sx={headerConfig[3].sx}>
        <FCheckbox
          data-testid={`${BT_SPVSN_ENUM.EXCEEDS_EXPECTATIONS}_${selectedValue.key}`}
          sx={{ margin: 0, flexGrow: 1, justifyContent: 'center', pointerEvents: 'none' }}
          iconStyles={{ pointerEvents: 'auto' }}
          disabled={!isEditable}
          checked={BT_SPVSN_ENUM.EXCEEDS_EXPECTATIONS === selectedValue.value}
          onChange={(_e: ChangeEvent<HTMLInputElement>) => {
            handleFieldUpdate(selectedValue.key, BT_SPVSN_ENUM.EXCEEDS_EXPECTATIONS);
          }}
        />
      </Box>
      <Box
        sx={{
          height: '100%',
          borderLeft: `1px solid ${getThemeColor(Themes.Primary).primary}`,
          borderRadius: '2px',
          marginLeft: '-2px',
        }}
      ></Box>

      <Box sx={headerConfig[4].sx}>
        <FCheckbox
          data-testid={`${BT_SPVSN_ENUM.NOT_EVALUATED}_${selectedValue.key}`}
          sx={{ margin: 0 }}
          disabled={!isEditable}
          checked={BT_SPVSN_ENUM.NOT_EVALUATED === selectedValue.value}
          onChange={(_e: ChangeEvent<HTMLInputElement>) => {
            handleFieldUpdate(selectedValue.key, BT_SPVSN_ENUM.NOT_EVALUATED);
          }}
        />
      </Box>
    </Box>
  );
}

export default BtSupervisionTableRow;
